module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0027.jpg?v=c69e725c";